import { buildProps } from '@jdesign-vue/utils'
import { dropdownProps } from '@jdesign-vue/components/dropdown'
import { useTooltipTriggerProps } from '@jdesign-vue/components/tooltip'
import type { StepType } from './guide'
import type { PropType } from 'vue'

export const guideHintProps = buildProps({
  placement: dropdownProps.placement,
  trigger: useTooltipTriggerProps.trigger,
  // 外部控制是否显示
  visible: {
    type: Boolean,
    default: true,
  },
  /**
   * @description disable the guide hint
   */
  disabled: Boolean,
  /**
   * @description ignore disabled from Form
   */
  ignoreFormDisabled: Boolean,
  // 是否显示右上角关闭按钮
  closable: {
    type: Boolean,
    default: false,
  },
  // 是否显示蒙层
  mask: {
    type: Boolean,
    default: false,
  },
  showArrow: {
    type: Boolean,
    default: true,
  },
  step: {
    type: Object as PropType<StepType>,
    default: () => ({}),
    required: true,
  },
  type: {
    type: String as PropType<'primary' | 'default'>,
    default: 'default',
  },
  offset: {
    type: Array as PropType<number[] | string[]>,
    default: [0, 0],
  },
  zIndex: {
    type: Number,
  },
  /**
   * 面板色彩
   * css 色值，当开启 color 时，Guide 面板文案与按钮颜色会反转
   */
  color: {
    type: String,
  },
  /**
   * 默认是否开启
   */
  open: {
    type: Boolean,
  },
  /**
   * 是否在页面变化时重新定位（解决缩放时位置偏移问题）
   */
  autoReposition: {
    type: Boolean,
    default: false,
  },
  panelClass: {
    type: String,
  },
  effect:{
    type:String as PropType<'dark' | 'light'>,
    default:'light'
  }
} as const)

export const guideHintEmits = {
  open: () => undefined,
  // 所有步骤均完成时触发
  finish: () => undefined,
  // 点击关闭/跳过时触发
  close: () => undefined,
}
